<script lang="ts" setup>
import { RadioGroupLabel, RadioGroupOption } from '@headlessui/vue'

defineProps<{
  label?: string
  value: any

  // Provided automatically by GRadioInput.
  hasErrors?: boolean
}>()
</script>

<template>
  <RadioGroupOption
    v-slot="{ active, checked }"
    as="div"
    :value="value"
    class="g-radio-option"
    :data-value="value"
  >
    <slot v-bind="{ value, active, checked }">
      <div class="flex items-center gap-2.5 py-2 cursor-pointer">
        <input
          class="
              appearance-none rounded-1
              h-3 w-3 ring-1 ring-offset-0 ring-grey-400
              text-primary-base outline-none
              checked:bg-primary-base
              checked:ring-1 checked:ring-primary-base checked:ring-offset-4
              ml-1
            "
          :style="hasErrors && '--tw-ring-color: red;'"
          :value="value"
          type="radio"
          :checked="checked"
        >
        <RadioGroupLabel
          as="span"
          class="cursor-pointer relative flex-1 font-medium"
          :class="checked ? 'text-navy' : 'text-v2-secondary'"
        >
          <slot name="label">{{ label }}</slot>
        </RadioGroupLabel>
      </div>
    </slot>
  </RadioGroupOption>
</template>
